var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOrangeStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "fe9e09f2-58b1-4a89-b622-c36a4ef8801f",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 95 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a6bca0ca-f448-499c-a008-0c7937d54857"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -0.07,
    y: 0.04,
    width: 95.77,
    height: 95.96,
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "39.9 32.41 16.8 9.31 9.19 16.91 32.29 40.01 -0.07 39.71 0.03 50.57 32.39 50.87 9.72 73.54 17.48 81.29 40.14 58.62 40.45 90.99 51.31 91.09 51 58.73 74.1 81.83 81.71 74.22 58.61 51.12 90.97 51.42 90.87 40.56 58.51 40.26 81.18 17.59 73.43 9.84 50.76 32.51 50.45 0.15 39.59 0.04 39.9 32.41",
    style: {
      fill: "#f6b11c"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#a6bca0ca-f448-499c-a008-0c7937d54857)"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "94.21 44.09 61.85 43.79 84.52 21.12 76.77 13.37 54.09 36.04 53.79 3.67 42.93 3.57 43.24 35.94 20.14 12.84 12.53 20.44 35.63 43.54 3.27 43.24 3.37 54.1 35.73 54.4 13.06 77.07 20.81 84.82 43.48 62.15 43.79 94.51 54.65 94.62 54.34 62.25 77.44 85.35 85.05 77.75 61.95 54.65 94.31 54.95 94.21 44.09",
    style: {
      fill: "none",
      stroke: "#122d51",
      strokeWidth: "1.5px"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangeStar);
export default __webpack_public_path__ + "static/media/orange-star.7c448dc1ef367827302bb38adc3834d2.svg";
export { ForwardRef as ReactComponent };